import { CompanyFetchProvider } from '@/features/companies/overview/company-fetch-context';
import { CompanyPage } from '@/features/companies/company.page';

export const SpotlightCompanyPage = () => (
  <CompanyFetchProvider mode="spotlight">
    <CompanyPage />
  </CompanyFetchProvider>
);
